import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'
import { addStyles } from 'ethcss'
import { defaultThemeStyles } from '../index.theme'
import { defaultThemeStyles as defaultThemeAppStyles } from 'blocks.app/app/app.theme.jcss'
import { colors, IStyles, mediaCSS } from '../../../../theme'
import { convertColor } from 'core/utils'

const solidPanelColor = convertColor(colors.greyLight, { format: 'hex' })

const ItemDisplaysStyles: IStyles = {
    displaysWrapper() {
        return {
            ...grid.col,
            boxShadow: `var(--var-module-catalog-component-item-style-shadow, ${defaultThemeStyles.shadow})`,
            cursor: 'pointer',
            overflow: 'hidden',
            [`&:hover .${this.checkWrapper}`]: {
                opacity: 1,
            },
            [`&:hover .${this.infoLine}`]: {
                height: 64,
            },
            [`&:hover .${this.infoLine6}`]: {
                height: 56,
            },
            [`&:hover .${this.infoLine8}`]: {
                height: 48,
            },
        }
    },
    groupWrapper() {
        return {
            ...item.hover,
            cursor: 'pointer',
            fontSize: 14,
            [`&:hover .${this.checkWrapper}`]: {
                opacity: 1,
            },
        }
    },
    group: {
        ...grid.col,
        ...grid.full,
        boxShadow: `var(--var-module-catalog-component-item-style-shadow, ${defaultThemeStyles.shadow})`,
        ...item.cover,
        ...item.rel,
        ...item.overNone,
        zIndex: 10,
        height: '90%',
        top: '10%',
        backgroundColor: `var(--var-module-device-component-group-style-backgroundColor, ${colors.grey})`,
    },
    groupBackWrapper: {
        ...grid.full,
        ...grid.colCenter,
        ...item.abs,
        top: 0,
        left: 0,
        zIndex: 1,
    },
    groupBack: {
        ...grid.fullHeight,
        boxShadow: '0 -1px 2px rgba(0, 0, 0, 0.12)',
        position: 'relative',
    },
    groupBack_first: {
        width: '94%',
        height: '90%',
        backgroundColor: solidPanelColor,
    },
    groupBack_second: {
        width: '88%',
        backgroundColor: `var(--var-module-catalog-component-item-style-backgroundMain, ${defaultThemeStyles.backgroundMain})`,
    },
    errorGroup: {
        backgroundColor: `var(--var-module-catalog-component-item-style-error, ${defaultThemeStyles.error})`,
    },
    onlineGroup: {
        backgroundColor: `var(--var-module-catalog-component-item-style-online, ${defaultThemeStyles.online})`,
    },
    offlineGroup: {
        backgroundColor: `var(--var-module-catalog-component-item-style-offlineGroup, ${defaultThemeStyles.offline})`,
    },
    sleepGroup: {
        backgroundColor: `var(--var-module-catalog-component-item-style-sleep, ${defaultThemeStyles.sleep})`,
    },
    online_display_offGroup: {
        backgroundColor: `var(--var-module-catalog-component-item-style-online-display-off, ${defaultThemeStyles.onlineDisplayOff})`,
    },
    preview: {
        backgroundColor: `var(--var-module-catalog-component-item-style-offline, ${defaultThemeStyles.offline})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
    },
    ping: {
        backgroundColor: `var(--var-module-catalog-component-item-style-ping, ${defaultThemeStyles.ping})`,
    },
    offline: {
        backgroundColor: `var(--var-module-catalog-component-item-style-offline, ${defaultThemeStyles.offline})`,
    },
    sleep: {
        backgroundColor: `var(--var-module-catalog-component-item-style-sleep, ${defaultThemeStyles.sleep})`,
    },
    online: {
        backgroundColor: `var(--var-module-catalog-component-item-style-online, ${defaultThemeStyles.online})`,
    },
    online_display_off: {
        backgroundColor: `var(--var-module-catalog-component-item-style-online-display-off, ${defaultThemeStyles.onlineDisplayOff})`,
    },
    updating: {
        backgroundColor: colors.updating,
    },
    error: { backgroundColor: `var(--var-module-catalog-component-item-style-error, ${defaultThemeStyles.error})` },
    blackLayer: {
        backgroundColor: `var(--var-module-catalog-component-item-style-active, ${defaultThemeStyles.active})`,
    },
    noBroadcast: {
        border: `1px solid var(--var-module-app-component-app-style-border, ${defaultThemeAppStyles.border})`,
        backgroundColor: `var(--var-module-catalog-component-item-style-backgroundMain, ${defaultThemeStyles.backgroundMain})`,
    },
    offlineText: { color: `var(--var-module-catalog-component-item-style-offline, ${defaultThemeStyles.offline})` },
    onlineText: { color: `var(--var-module-catalog-component-item-style-online, ${defaultThemeStyles.online})` },
    errorText: { color: `var(--var-module-catalog-component-item-style-error, ${defaultThemeStyles.error})` },
    noBroadcastText: {
        color: `var(--var-module-catalog-component-item-style-noBroadcastText, ${defaultThemeStyles.noBroadcastText})`,
    },
    content: {
        ...grid.space,
        ...grid.colCenter,
        position: 'relative',
    },
    iconWrapper: {
        position: 'absolute',
        fontSize: 24,
        ...grid.rowCenter,
        width: 24,
        height: 24,
        backgroundColor: `var(--var-module-catalog-component-item-style-iconWrapper, ${defaultThemeStyles.iconWrapper})`,
        borderRadius: '50%',
        top: grid.p_microPlus.padding,
        right: grid.p_mini.padding,
    },
    registrationCode: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: '38%',
        zIndex: 1,
        textAlign: 'center',
        fontWeight: 'bold',
        textShadow: '0 1px 3px rgba(80, 80, 80, 0.85), 0 0 6px rgba(90, 90, 90, 0.5)',
        color: `var(--var-module-catalog-component-item-style-textMain, ${defaultThemeStyles.textMain})`,
    },
    registrationCodeSimple: {
        ...grid.mt_micro,
        color: `var(--var-module-catalog-component-item-style-textMain, ${defaultThemeStyles.textMain})`,
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 16,
    },
    simpleWrapper: {
        ...grid.rowCenter,
        ...grid.full,
    },
    checkWrapper: {
        position: 'absolute',
        ...item.transitionErase,
        top: grid.p_micro.padding,
        right: grid.p_micro.padding,
        zIndex: 2,
        opacity: 0,

        [mediaCSS.tab]: {
            opacity: 1,
            right: 0,
        },
    },
    checkWrapperColExtra: {
        top: '2px !important',
        right: '2px !important',
    },
    iconWrapper_broadcast: {
        backgroundColor: `var(--var-module-catalog-component-item-style-backgroundSub, ${defaultThemeStyles.backgroundSub})`,
    },
    loading: {
        ...grid.row,
        ...grid.normalCenter,
        ...grid.noWrap,
        color: `var(--var-module-catalog-component-item-style-panel, ${defaultThemeStyles.panel})`,
        fontSize: 12,
    },
    progress: {
        ...grid.mr_micro,
        ...grid.normalCenter,
        ...grid.row,
        width: 20,
        height: 20,
    },
    infoLine: {
        position: 'absolute',
        ...grid.fullWidth,
        ...grid.p_microPlus,
        ...grid.justify,
        ...grid.row,
        ...grid.noWrap,
        color: `var(--var-module-catalog-component-item-style-panel, ${defaultThemeStyles.panel})`,
        fontSize: 14,
        ...item.transitionEraseHeight,
        bottom: 0,
        left: 0,
        height: 36,
        boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.05)',
    },
    infoLine6: {
        ...grid.p_nano,
        height: 24,
    },
    infoLine8: {
        ...grid.p_nano,
        height: 24,
    },
    infoLineProgress: {
        visibility: 'visible',
    },
    infoText: {},
    pseudoIcon: {
        width: 25,
    },
    infoIcon: {
        position: 'absolute',
        right: 10,
        bottom: 10,
    },
    // orientationIcon: {
    //     ...grid.mr_mini,
    // },
    statusPanel: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        ...grid.around,
        color: `var(--var-module-catalog-component-item-style-textMain, ${defaultThemeStyles.textMain})`,
        fontSize: 12,
        textAlign: 'center',
    },
    statusesRow: {
        display: 'flex',
        margin: '0.8em 0',
    },
    statusPanel6: {
        zoom: 0.7,
        transform: 'translate(-50%, -33%)',
        [mediaCSS.tab]: {
            zoom: 1,
        },
    },
    statusPanel8: {
        zoom: 0.7,
        transform: 'translate(-50%, -25%)',
        [mediaCSS.tab]: {
            zoom: 0.6,

            [mediaCSS.tabMini]: {},
        },
    },
    titleStyles: {
        fontSize: '114%',
    },
    displayText: {
        padding: '1px 0 0 0',

        [mediaCSS.desktop]: {
            padding: '1px 4px 0 2px',
        },
    },
    displayTextGroup: {
        padding: '7px 0 3px 0',

        [mediaCSS.desktop]: {
            padding: '1px 4px 0 2px',

            [mediaCSS.tab]: {
                fontSize: '12px !important',
            },
        },
    },
    blocked: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
    },
    blockedImg: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    iptvNowPlaying: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        backgroundColor: 'rgba(0,0, 0, 0.8)',
        padding: '4px 12px',
        color: colors.white,
        textAlign: 'center',
        fontSize: 12,
    },
}

addStyles(ItemDisplaysStyles)
export default ItemDisplaysStyles
